<template>
  <div class="px-page mb-8">
    <h2 class="font-semibold text-xl leading-tight">
      Orders | Left to Ship
    </h2>
  </div>

  <div class="card">
    <table class="table">
      <thead>
        <tr>
          <TableHeading
            label="Order Number"
            ref="heading_order_number"
            class="w-80"
            v-bind:hasSort="true"
            defaultSort="asc"
            v-bind:onlySort="['asc', 'desc']"
            v-on:sort="sortColumn($event, 'order_number', heading_order_number)"
          />
          <TableHeading
            label="Ordered At"
            ref="heading_ordered_at"
            class="w-80"
            v-bind:hasSort="true"
            v-bind:onlySort="['asc', 'desc']"
            v-on:sort="sortColumn($event, 'created_at',  heading_ordered_at)"
          />
          <TableHeading
            label="Notes"
            ref="heading_notes"
            v-bind:hasSort="true"
            v-bind:onlySort="['asc', 'desc']"
            v-on:sort="sortColumn($event, 'notes',  heading_notes)"
          />
        </tr>
      </thead>
      <tbody>
        <template v-if="orders.length" v-for="order in orders">
          <tr>
            <td><Link v-bind:href="$route('orders.show', order.order_number)">{{ order.order_number }}</Link></td>
            <td>{{ order.ordered_on }}</td>
            <td><span v-text="order.notes" /></td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { Link, router } from "@inertiajs/vue3";
import TableHeading from "../../components/TableHeading.vue";

const { orders } = defineProps(['orders']);

const heading_order_number = ref();
const heading_ordered_at = ref();
const heading_notes = ref();
const headings = ref([
  heading_order_number,
  heading_ordered_at,
  heading_notes
]);

const sort = ref('order_number');

const sortColumn = (direction, column, heading) => {
  clearSort(heading);

  if (direction === 'desc') {
    sort.value = `-${column}`;
  } else if (direction === 'asc') {
    sort.value = column;
  } else {
    sort.value = null;
  }

  router.get(route('orders.left-to-ship'), { sort: sort.value }, { preserveState: true });
};

const clearSort = (column) => {
  for (const {value: heading} of headings.value) {
    if (heading !== column) {
      heading.sort = 'none';
    }
  }

  sort.value = null;
};
</script>
